import { render, staticRenderFns } from "./setting-chips.vue?vue&type=template&id=11c230e5"
import script from "./setting-chips.ts?vue&type=script&lang=ts&external"
export * from "./setting-chips.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports